@if (!vm().tokenError) {
  <div class="mt-20 flex h-full flex-col items-center gap-4 text-center text-text-secondary">
    <img class="mt-11 h-[160px] w-[160px] items-center" src="assets/images/logo-beta-header.svg" width="160" height="160" />
    <h1 class="text-h1 font-medium text-text-primary">Thank you for your feedback!</h1>
    <p class="mt-11 text-h4 font-light text-text-secondary">
      <!-- TODO: get the provider from the contract, currently it is not there -->
      <strong class="font-semibold">We will notify Kevin Farrell</strong>, no further action is required. You can close this window now.
    </p>

    <button class="btn-primary mt-11 h-10 w-fit" (click)="onCloseClick()">
      {{ 'site_setup_form_sent_modal_button' | translate }}
    </button>
  </div>
} @else {
  <h4 class="mt-14 flex items-center text-h1 font-semibold">Error getting contract...</h4>
}
